"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.filterGroupsReducer = void 0;
const filters_1 = require("../actions/filters");
const initState = {};
const filterGroupsReducer = (filterGroups = initState, action) => {
    switch (action.type) {
        case filters_1.SET_FILTER_GROUPS:
            return Object.assign({}, action.payload);
        default:
            return filterGroups;
    }
};
exports.filterGroupsReducer = filterGroupsReducer;
//# sourceMappingURL=filterGroups.reducer.js.map